module.exports = __webpack_public_path__ + "static/media/codeColorSliders.2ae940ef.png";